export const PRE_CUT_IMAGE_CONFIG = {
  w: 284,
  h: 336,
  q: 75,
  auto: "format"
};
